import styles from './SegmentedBinarySwitch.module.css';

/**
 * Two-option segmented control. Click anywhere (or Space/Enter) toggles between left and right;
 * uses role="switch" with aria-checked = left option active.
 */
export function SegmentedBinarySwitch({
    leftLabel,
    rightLabel,
    selectedLeft,
    tone = 'default',
    onSelectLeft,
    onSelectRight,
    ariaLabelledBy,
    ariaLabel,
    className,
}) {
    const rightSelected = !selectedLeft;

    function flip() {
        if (selectedLeft) onSelectRight();
        else onSelectLeft();
    }

    function onKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            flip();
        }
    }

    const trackClass = [
        styles.wandSegmentedTrack,
        styles.wandSegmentedSwitch,
        tone === 'item' ? styles.wandSegmentedTrackItem : '',
        className || '',
    ]
        .filter(Boolean)
        .join(' ');

    const pillClass = [
        styles.wandSegmentPill,
        selectedLeft ? styles.wandSegmentPillLeft : styles.wandSegmentPillRight,
        tone === 'item' && rightSelected ? styles.wandSegmentPillShrink : '',
    ]
        .filter(Boolean)
        .join(' ');

    const leftTextClass = [
        styles.wandSegment,
        styles.wandSegmentFace,
        selectedLeft ? styles.wandSegmentLabelActive : styles.wandSegmentLabelMuted,
        tone === 'item' && selectedLeft ? styles.wandSegmentLabelGrow : '',
    ]
        .filter(Boolean)
        .join(' ');

    const rightTextClass = [
        styles.wandSegment,
        styles.wandSegmentFace,
        rightSelected ? styles.wandSegmentLabelActive : styles.wandSegmentLabelMuted,
        tone === 'item' && rightSelected ? styles.wandSegmentLabelShrink : '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div
            role="switch"
            tabIndex={0}
            aria-checked={selectedLeft}
            aria-labelledby={ariaLabelledBy || undefined}
            aria-label={ariaLabelledBy ? undefined : ariaLabel}
            className={trackClass}
            onClick={flip}
            onKeyDown={onKeyDown}
        >
            <span className={pillClass} aria-hidden="true" />
            <span className={leftTextClass}>{leftLabel}</span>
            <span className={rightTextClass}>{rightLabel}</span>
        </div>
    );
}
